$(document).ready(function () {
    Sentry.init({
        dsn:
            'https://ff47e087ddf9448c93d2efc7cc48a036@o371839.ingest.sentry.io/5185460',
        // beforeSend(event, hint) {
        //     // Check if it is an exception, and if so, show the report dialog
        //     // if (event.exception) {
        //     //     Sentry.showReportDialog({ eventId: event.event_id })
        //     // }
        //     // return event
        // },
    })

    //frontendsentrytestfunction()
})
